// extracted by mini-css-extract-plugin
export var blogLinks = "style-guide-module--blog-links--SL5zq";
export var codeExample = "style-guide-module--code-example--Sf3vk";
export var codeInline = "style-guide-module--code-inline--Tf8+Y";
export var content = "style-guide-module--content--nw2ih";
export var header = "style-guide-module--header--HKF9P";
export var linkDoc = "style-guide-module--link-doc--BHPax";
export var nav = "style-guide-module--nav--fF+WF";
export var navLink = "style-guide-module--nav-link--sr1Ko";
export var wrapper = "style-guide-module--wrapper--1yj2f";